import qalaWishlist from './qalaWishlist';
import sizeguide from './sizeguide';
import qalaDepict from './qalaDepict';

class integrations {
	constructor() {
		if ( QalaBuy.settings.enable_wishlist === 'yes' ) {
			new qalaWishlist();
		}

		if ( QalaBuy.settings.enable_depict === 'yes' ) {
			new qalaDepict();
		}

		new sizeguide();
	}
}

export default integrations;
